import React from 'react';
import { Instagram, Youtube } from 'lucide-react';

/**
 * Shared social links — used in every public-page footer.
 * Pass `variant="dark"` on dark-background footers (Landing, How-it-works hero footer).
 */
export default function SocialLinks({ variant = 'light' }) {
  const textColor = variant === 'dark' ? 'text-white/80 hover:text-white' : 'text-text-secondary hover:text-primary';
  return (
    <div className="flex items-center justify-center gap-4" data-testid="footer-social-links">
      <a
        href="https://www.instagram.com/mddreminder"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow My Direct Debits on Instagram"
        data-testid="footer-instagram-link"
        className={`inline-flex items-center gap-1.5 text-sm transition-colors ${textColor}`}
      >
        <Instagram className="w-4 h-4" />
        <span>Instagram</span>
      </a>
      <span className={variant === 'dark' ? 'text-white/30' : 'text-text-light/40'}>·</span>
      <a
        href="https://www.youtube.com/@mydirectdebitreminderapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Subscribe to My Direct Debits on YouTube"
        data-testid="footer-youtube-link"
        className={`inline-flex items-center gap-1.5 text-sm transition-colors ${textColor}`}
      >
        <Youtube className="w-4 h-4" />
        <span>YouTube</span>
      </a>
    </div>
  );
}
